module.exports = __webpack_public_path__ + "img/collaborate-space.647136c7.png";